import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import AlertDialog from './AlertDialog';

interface MessageFormProps {
  onSubmit: (data: MessageFormData) => Promise<void>;
}

export interface MessageFormData {
  name: string;
  content: string;
}

const MessageForm: React.FC<MessageFormProps> = ({ onSubmit }) => {
  const { register, handleSubmit, formState: { errors, isSubmitting }, reset } = useForm<MessageFormData>();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  
  const onSubmitHandler = async (data: MessageFormData) => {
    try {
      await onSubmit(data);
      reset();
    } catch (error) {
      console.error('Error submitting message:', error);
      setAlertMessage('Erro ao enviar mensagem. Por favor, tente novamente.');
      setShowAlert(true);
    }
  };

  return (
    <>
      <form 
        onSubmit={handleSubmit(onSubmitHandler)}
        className="bg-white rounded-lg shadow-md p-6 max-w-lg mx-auto"
      >
        <div className="mb-4">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
            Seu nome
          </label>
          <input
            id="name"
            type="text"
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-wedding-blue-500 ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
            {...register('name', { required: 'Nome é obrigatório' })}
          />
          {errors.name && (
            <p className="text-red-500 text-xs mt-1">{errors.name.message}</p>
          )}
        </div>
        
        <div className="mb-6">
          <label htmlFor="content" className="block text-sm font-medium text-gray-700 mb-1">
            Sua mensagem
          </label>
          <div className="relative">
            <textarea
              id="content"
              rows={5}
              maxLength={500}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-wedding-blue-500 ${errors.content ? 'border-red-500' : 'border-gray-300'}`}
              {...register('content', { 
                required: 'Mensagem é obrigatória',
                maxLength: {
                  value: 500,
                  message: 'A mensagem deve ter no máximo 500 caracteres'
                }
              })}
            />
            <div className="absolute bottom-2 right-2 text-xs text-gray-500">
              <span>{register('content').value?.length || 0}</span>/500
            </div>
          </div>
          {errors.content && (
            <p className="text-red-500 text-xs mt-1">{errors.content.message}</p>
          )}
        </div>
        
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-3 bg-wedding-blue-600 text-white rounded-md hover:bg-wedding-blue-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
        >
          {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
        </button>
      </form>

      <AlertDialog
        isOpen={showAlert}
        title="Erro"
        message={alertMessage}
        onClose={() => setShowAlert(false)}
      />
    </>
  );
};

export default MessageForm;